var React = require('react');

function ContextMenuArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 5a1 1 0 0 1 0 1.414l-7 7-7-7A1 1 0 0 1 2.414 5L8 10.586 13.586 5A1 1 0 0 1 15 5z","fill":"#fff"}));
}

ContextMenuArrowDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ContextMenuArrowDown;

ContextMenuArrowDown.default = ContextMenuArrowDown;
